<div>
  <div class="modal-header pb-4">
    <div class="col">
      <h4 class="modal-title fw-bold" id="modal-basic-title">Bulk Upload Rates</h4>
      <span class="text-muted small">Select category and locations</span>
    </div>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
  </div>

  <div class="modal-body pt-3">


    <form [formGroup]="rateForm">

      <div class="wizard-step" [class.active]="currentStep === 1 && !isPreviewed">
        <div class="row gy-3">

          <div class="rounded-3 p-3">
            <h6 class="fw-semibold mb-3 text-secondary">
              <i class="bi bi-grid me-2"></i> Select Category
            </h6>
            <div class="row g-3">
              <div class="col-4" *ngFor="let cat of categoryTypeArray">
                <div
                  class="border rounded p-3 hover-bg-light cursor-pointer d-flex justify-content-between align-items-center"
                  [class]="
              'border rounded p-3 hover-bg-light cursor-pointer ' +
              (selectedCategoryID === cat.value ? 'border-secondary bg-secondary-subtle' : '')
            " (click)="onChangeCategory(cat)">

                  <div>
                    <div class="fw-semibold">{{ cat.label }}</div>
                    <div class="text-muted small">{{ cat.description }}</div>
                  </div>

                  <i class="bi bi-check text-secondary fs-4" *ngIf="selectedCategoryID === cat.value"></i>

                </div>
              </div>
            </div>
          </div>

        </div>


      </div>

      <div class="wizard-step" [class.active]="currentStep === 2 && !isPreviewed">
        <div class="d-flex align-items-start bg-info-subtle border border-info-subtle rounded p-4 gap-3 w-100">
          <i class="bi bi-info-circle-fill text-info fs-3"></i>
          <div class="row gy-2 flex-grow-1">
            <div class="fw-bold">
              Download Template First
            </div>
            <div>
              Download the CSV template specific to <span class="fw-bold">{{selectedCategory.toLowerCase()}}</span> to ensure your file has the correct format.
            </div>
            <div>
              <button type="button" (click)="downloadTemplate()" class="btn btn-primary"><i
                  class="bi bi-download text-info text-sm me-2"></i>Download
                Template</button>
            </div>
          </div>
        </div>

        <div class="d-flex align-items-start bg-light border rounded p-2 gap-3 w-100 mt-4">
          <div class="flex-grow-1 text-small">
            <span class="fw-bold">Category:</span> {{selectedCategory}}
          </div>
        </div>

        <div class="drag-area mt-4" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
          (drop)="onFileDrop($event)" [class.dragover]="isDragOver">
          <div class="text-center">
            <i class="bi bi-upload fs-1 text-secondary"></i>
            <p class="fw-bold mt-2">
              <!-- Show selected file name or default text -->
              {{ uploadedFile ? uploadedFile.name : 'Drag & drop your CSV file here, or click to browse' }}
            </p>

            <input type="file" accept=".csv" class="file-input" (change)="onFileSelect($event)">
          </div>
        </div>


      </div>

      <div class="wizard-step" [class.active]="isPreviewed">
        <div class="bg-light border rounded p-4 text-center">
            <i class="bi bi-file-earmark-check-fill text-success fs-1"></i>
            <h5 class="fw-bold mt-3">Ready to Upload</h5>
            <p class="text-muted">File validation passed! Your rates are ready to be processed.</p>

            <div class="d-flex justify-content-center gap-2 mt-4 flex-wrap">
                <div class="text-center px-3 border-end">
                    <div class="fw-bold fs-4">{{previewData?.total_rows || 0}}</div>
                    <div class="small text-muted text-uppercase">Total Rows</div>
                </div>
                <div class="text-center px-3 border-end text-success">
                    <div class="fw-bold fs-4">{{(previewData?.created_rates || 0) + (previewData?.updated_rates || 0)}}</div>
                    <div class="small text-muted text-uppercase">Valid Rates</div>
                </div>
                <div class="text-center px-3 border-end text-warning">
                    <div class="fw-bold fs-4">{{previewData?.skipped_routes || 0}}</div>
                    <div class="small text-muted text-uppercase">Skipped</div>
                </div>
                <div class="text-center px-3 border-end text-warning" *ngIf="previewData?.warnings?.length > 0">
                    <div class="fw-bold fs-4">{{previewData?.warnings?.length || 0}}</div>
                    <div class="small text-muted text-uppercase">Warnings</div>
                </div>
                <div class="text-center px-3 text-danger" *ngIf="previewData?.errors?.length > 0">
                    <div class="fw-bold fs-4">{{previewData?.errors?.length || 0}}</div>
                    <div class="small text-muted text-uppercase">Errors</div>
                </div>
            </div>
        </div>

        <!-- Detailed Tabs (Errors & Warnings) -->
        <div class="mt-4" *ngIf="previewData?.errors?.length > 0 || previewData?.warnings?.length > 0">
          <ul class="nav nav-tabs">
            <li class="nav-item" (click)="setActiveTab('errors')">
              <a class="nav-link cursor-pointer" [class.active]="activeTab === 'errors'" [class.text-danger]="previewData?.errors?.length > 0">
                Errors ({{previewData?.errors?.length || 0}})
              </a>
            </li>
            <li class="nav-item" (click)="setActiveTab('warnings')">
              <a class="nav-link cursor-pointer" [class.active]="activeTab === 'warnings'" [class.text-warning]="previewData?.warnings?.length > 0">
                Warnings ({{previewData?.warnings?.length || 0}})
              </a>
            </li>
          </ul>

          <div class="tab-content border border-top-0 rounded-bottom bg-white" style="max-height: 300px; overflow-y: auto;">
            <!-- Errors Panel -->
            <div class="tab-pane fade show active" *ngIf="activeTab === 'errors'">
              <div *ngIf="previewData?.errors?.length > 0; else noErrors">
                <table class="table table-sm table-hover mb-0">
                  <thead class="bg-light sticky-top">
                    <tr>
                      <th class="px-3 py-2 text-center" style="width: 80px;">Row</th>
                      <th class="px-3 py-2">Problem Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let err of previewData.errors">
                      <td class="px-3 py-2 text-center fw-bold text-secondary bg-light">{{err.row}}</td>
                      <td class="px-3 py-2 text-danger">{{err.error || err.message}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <ng-template #noErrors>
                <div class="p-4 text-center text-muted">No errors detected.</div>
              </ng-template>
            </div>

            <!-- Warnings Panel -->
            <div class="tab-pane fade show active" *ngIf="activeTab === 'warnings'">
              <div *ngIf="previewData?.warnings?.length > 0; else noWarnings">
                <table class="table table-sm table-hover mb-0">
                  <thead class="bg-light sticky-top">
                    <tr>
                      <th class="px-3 py-2 text-center" style="width: 80px;">Row</th>
                      <th class="px-3 py-2">Warning Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let warn of previewData.warnings">
                      <td class="px-3 py-2 text-center fw-bold text-secondary bg-light">{{warn.row}}</td>
                      <td class="px-3 py-2 text-warning">{{warn.message || warn.warning || warn.error}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <ng-template #noWarnings>
                <div class="p-4 text-center text-muted">No warnings detected.</div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>

    </form>



  </div>

  <div class="modal-footer d-flex justify-content-between">
    <button class="btn btn-light" (click)="closeModal()">Cancel</button>

    <div class="d-flex flex-row gap-4">
      <button class="btn btn-primary" *ngIf="currentStep != 1 || isPreviewed" (click)="goToPrevStep()">
        Prev
      </button>

      <!-- Step 2 -> Preview Mode -->
      <button class="btn btn-secondary text-white" *ngIf="isSaveButtonEnabled && !isPreviewed"
        [disabled]="!uploadedFile || isSubmitting" (click)="handleBulkUpload()">
        <span *ngIf="!isSubmitting">Validate & Preview</span>
        <span *ngIf="isSubmitting"><i class="bi bi-arrow-repeat spin"></i> Validating...</span>
      </button>

      <!-- Step 3 (Preview) -> Actual Upload -->
      <button class="btn btn-success text-white" *ngIf="isPreviewed"
        [disabled]="isSubmitting" (click)="handleBulkUpload()">
        <span *ngIf="!isSubmitting">Proceed to Upload</span>
        <span *ngIf="isSubmitting"><i class="bi bi-arrow-repeat spin"></i> Uploading...</span>
      </button>

      <!-- Step 1 -> Step 2 -->
      <button class="btn btn-secondary text-white" *ngIf="!isSaveButtonEnabled && !isPreviewed" [disabled]="!selectedCategoryID"
        (click)="goToNextStep()">
        Next
      </button>
    </div>


  </div>
</div>
